module.exports = __webpack_public_path__ + "static/media/bitbucket.1964dbe0.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/bitbucket.ico
// module id = 75
// module chunks = 0